import {takeEvery} from 'redux-saga/effects'
import {
  ONBOARDING_AI_ALLOCATION,
  ONBOARDING_COMPLETE,
  ONBOARDING_EXTRACT_TEACHERS,
  ONBOARDING_FILE_PREFILL,
  ONBOARDING_GET_DATA,
  ONBOARDING_LESSON_PLANNING_TEMPLATE,
  ONBOARDING_SEED_SAMPLE_DATA,
  ONBOARDING_STUDENTS_TEMPLATE,
  ONBOARDING_TIMETABLE_COUNTRIES,
  ONBOARDING_TIMETABLE_CURRICULA,
  ONBOARDING_TIMETABLE_PREFILL,
  ONBOARDING_TRACK_EVENTS,
} from 'setup/redux/Actions/Onboarding/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* onboardingSagas() {
  yield takeEvery(ONBOARDING_AI_ALLOCATION, fetchData)
  yield takeEvery(ONBOARDING_EXTRACT_TEACHERS, fetchData)
  yield takeEvery(ONBOARDING_FILE_PREFILL, fetchData)
  yield takeEvery(ONBOARDING_SEED_SAMPLE_DATA, fetchData)
  yield takeEvery(ONBOARDING_GET_DATA, fetchData)
  yield takeEvery(ONBOARDING_COMPLETE, fetchData)
  yield takeEvery(ONBOARDING_LESSON_PLANNING_TEMPLATE, fetchData)
  yield takeEvery(ONBOARDING_STUDENTS_TEMPLATE, fetchData)
  yield takeEvery(ONBOARDING_TIMETABLE_COUNTRIES, fetchData)
  yield takeEvery(ONBOARDING_TIMETABLE_CURRICULA, fetchData)
  yield takeEvery(ONBOARDING_TIMETABLE_PREFILL, fetchData)
  yield takeEvery(ONBOARDING_TRACK_EVENTS, fetchData)
}

export default onboardingSagas
